import axiosInstance, {
  axiosAlertInstance,
  axiosInventoryInstance,
} from '@/config/apiConfig';
import { AxiosResponse } from 'axios';
import { API_URL_CONFIG } from '@/config/urlConfig/apiUrlConfig';
import { VDI_VERSION } from '@/constant/gatewayTransaction/gatewayTransaction.constant';
import {
  IApiResponse,
  IDashboard,
  IDashboardVdiTransactionsCount,
} from './dashboard.type';

// Define the User interface representing the structure of the user object returned by the API

export const fetchVdiTransaction = ({
  startDate,
  endDate,
  version = VDI_VERSION[1]?.id,
  selectedTimezone,
}: IDashboardVdiTransactionsCount): Promise<
  AxiosResponse<IApiResponse, any>
> => {
  return axiosInstance({
    url: API_URL_CONFIG.DASHBOARD.GET_VDI_TRANSACTION,
    params: {
      version,
      startDate,
      endDate,
      selectedTimezone,
    },
  });
};

export const fetchQuikpickProduct = ({
  startDate,
  endDate,
}: IDashboard): Promise<AxiosResponse<IApiResponse, any>> => {
  return axiosInventoryInstance({
    url: API_URL_CONFIG.DASHBOARD.GET_QUIK_PICK,
    params: {
      startDate,
      endDate,
    },
  });
};

export const fetchAlert = ({
  startDate,
  endDate,
}: IDashboard): Promise<AxiosResponse<IApiResponse, any>> => {
  return axiosAlertInstance({
    url: API_URL_CONFIG.DASHBOARD.GET_ALERT,
    params: {
      startDate,
      endDate,
    },
  });
};

export const fetchSmartCoolerProduct = ({
  startDate,
  endDate,
}: IDashboard): Promise<AxiosResponse<IApiResponse, any>> => {
  return axiosInventoryInstance({
    url: API_URL_CONFIG.DASHBOARD.GET_SMART_COOLER_PRODUCT_COUNT,
    params: {
      // ...(startDate ? { startDate } : {}),
      // ...(endDate ? { endDate } : {}),
    },
  });
};
